import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { businessCardApi } from "../../../../../services/company-office/BusinessCard.service";

export const useBCRequest = () => {
  const { id } = useParams<{ id: string }>();
  return useQuery({
    queryKey: ["BC-requests", id],
    queryFn: () => businessCardApi.getRequest(id),
    select: businessCardApi.toResponse,
  });
};
